import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/auth-context";
import { cn } from "../lib/cn";
import { Button } from "./ui/button";

// Zeile unter der Karte auf Einstiegsseiten nach dem Login (Mandantenwahl,
// Onboarding): mit welchem Konto man angemeldet ist, und „Abmelden“.
// Ohne Anmeldung zeigt sie nichts, damit sie auch auf gemischten Seiten
// (z. B. Fehlerseiten) gefahrlos stehen kann.
// wide: gleiche Breite wie die Karte darüber (siehe CenteredPage).
export function AccountBar({ wide = false }: { wide?: boolean }) {
  const { t } = useTranslation();
  const auth = useAuth();
  if (auth.state.status !== "authenticated") return null;
  const { email } = auth.state.user;

  return (
    <div
      className={cn(
        "flex w-full flex-wrap items-center justify-between gap-x-4 gap-y-2 text-sm text-ink-muted",
        wide ? "max-w-lg" : "max-w-sm",
      )}
    >
      {/* min-w-0 + truncate: lange Adressen werden gekürzt statt umzubrechen */}
      {email && <span className="min-w-0 truncate">{t("nav.signedInAs", { email })}</span>}
      <Button variant="secondary" size="md" onClick={() => void auth.logout()}>
        {t("nav.logout")}
      </Button>
    </div>
  );
}
